module.exports = __webpack_public_path__ + "75cc049cdd42bc72ea02b997169ca5a0.png";